var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-create-layout',[_c('stat-question-sections-form',{attrs:{"title":_vm.title,"section":_vm.parent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }